import React from "react";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export function Quote() {
  const { t } = useTranslation();

  //TODO: info@trybook.com.au

  return (
    <div>
      {/* <h3 className="m-3">{t("About")} </h3> */}
      <p className="mx-5">Quote Page to be edited </p>
     
    </div>
  );
}